// extracted by mini-css-extract-plugin
export default {"page":"camera-page_page__AyKjo","bottombar":"camera-page_bottombar__veTpi"};